import { Select } from '@/components/ui/select';
import { useTableContext } from '@/contexts/table-context';

import { useDashboardFilters } from './use-dashboard-filters';

export function Filters() {
  const { setFilters } = useTableContext();
  const filters = useDashboardFilters();

  const handleApply = (
    selectedValues: (string | boolean | undefined)[],
    key: string,
  ) => {
    setFilters(prev => ({
      ...prev,
      [key]: selectedValues,
    }));
  };

  return (
    <div className="flex flex-row gap-2">
      {filters.map(filter => (
        <Select
          key={filter.label}
          id={filter.filterKey}
          options={filter.options ?? []}
          selectedValues={filter.selectedValues}
          prefixText={`${filter.label}:`}
          query={filter.query}
          setQuery={filter.setQuery}
          isLoading={filter.isFetching}
          onApply={handleApply}
          className="rounded-lg"
        />
      ))}
    </div>
  );
}
